import { ArrowForwardIcon } from "@chakra-ui/icons";
import { Button, ButtonProps, HStack } from "@chakra-ui/react";
import { Link } from "gatsby";
import React from "react";
import { If, Then } from "react-if";
import { ButtonLink } from "@types/common";

interface Props extends ButtonProps {
  action: ButtonLink;
}

const LinkActionButton: React.FC<Props> = ({ action, ...rest }) => {
  return (
    <If condition={action != undefined}>
      <Then>
        <Link to={action.slug}>
          <HStack>
            <Button textStyle={"hind_m"} variant={action.variant} {...rest}>
              {action.label}

              <If condition={action?.icon != undefined}>
                <Then>
                  <ArrowForwardIcon color={"primary"} boxSize={5} ml={2} />
                </Then>
              </If>
            </Button>
          </HStack>
        </Link>
      </Then>
    </If>
  );
};

export default LinkActionButton;
